import { render, staticRenderFns } from "./ProjectWindow.vue?vue&type=template&id=20dc94ec&scoped=true&lang=pug&"
import script from "./ProjectWindow.vue?vue&type=script&lang=ts&"
export * from "./ProjectWindow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20dc94ec",
  null
  
)

export default component.exports